import { type SVGProps } from 'react';

export const UserProfileIcon = (props: SVGProps<SVGSVGElement>): React.ReactElement => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 39.5C12 35.5 13.2 27 24 27" stroke="#404040" />
      <path d="M36 39.5C36 35.5 34.8 27 24 27" stroke="#404040" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.0039 5.00781C13.5105 5.00781 5.00391 13.5144 5.00391 24.0078C5.00391 34.5012 13.5105 43.0078 24.0039 43.0078C34.4973 43.0078 43.0039 34.5012 43.0039 24.0078C43.0039 13.5144 34.4973 5.00781 24.0039 5.00781ZM4.00391 24.0078C4.00391 12.9621 12.9582 4.00781 24.0039 4.00781C35.0496 4.00781 44.0039 12.9621 44.0039 24.0078C44.0039 35.0535 35.0496 44.0078 24.0039 44.0078C12.9582 44.0078 4.00391 35.0535 4.00391 24.0078Z"
        fill="#404040"
      />
      <circle cx="24" cy="17" r="5.5" stroke="#404040" />
    </svg>
  );
};
